import { Box, Typography } from '@mui/material';
import { ReactComponent as ErrorCircleSvg } from "../../loginImages/error-circle.svg";
import { myVJRed100 } from "../../constants/brandingColors";

const ExclamationError = ({ errorText, size = 14 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box
        sx={{
          position: 'relative',
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <ErrorCircleSvg width={size} height={size} />
      </Box>
      <Typography title={errorText} variant="subtitle2" noWrap sx={{ color: myVJRed100, maxWidth: '600px' }}>{errorText}</Typography>
    </Box>
  );
};

export default ExclamationError;